// This file registers the application's Stimulus controllers.
import { application } from "./application"

import FlashController from "./flash_controller"
import DependencyController from "./dependency_controller"
import ContactSelectController from "./contact_select_controller"
import PilotFilterController from "./pilot_filter_controller"
import TableController from "./table_controller"

application.register("flash", FlashController)
application.register("dependency", DependencyController)
application.register("contact-select", ContactSelectController)
application.register("pilot-filter", PilotFilterController)
application.register("table", TableController)
